var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
var ToggleComponent = /** @class */ (function (_super) {
    __extends(ToggleComponent, _super);
    function ToggleComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.toggle = false;
        _this.frame = true;
        return _this;
    }
    ToggleComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && typeof this.component.params.frame !== 'undefined') {
            this.frame = this.component.params.frame;
        }
    };
    ToggleComponent.prototype.setUnsubscribe = function () {
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ToggleComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + 'ToggleReset') {
            this.toggle = false;
        }
    };
    ToggleComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ToggleComponent.prototype.switchToggle = function () {
        this.toggle = !this.toggle;
    };
    ToggleComponent.prototype.setChangeCompData = function (component) {
        this.component.title = component.title;
    };
    ToggleComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'toggle',
                    template: "<div class=\"filter\" id=\"{{ componentName }}\">\n  <p class=\"filter_trigger\"><span [class.open]=\"toggle\" (click)=\"switchToggle()\">{{ component.title }}</span></p>\n  <div class=\"-p-0 -mt-05\" [class.stageFlowPane_border]=\"frame\" style=\"margin-left: 15px;\" [style.display]=\"toggle ? 'block': 'none'\">\n    <ng-template ngFor let-comp [ngForOf]=\"component.components\">\n      <content [component]=\"comp\"></content>\n    </ng-template>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    ToggleComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return ToggleComponent;
}(ContentBaseComponent));
export { ToggleComponent };
//# sourceMappingURL=toggle.component.js.map